<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'password-change'">
  <app-change-password/>
</app-user-dashboard>

